module.exports = __webpack_public_path__ + "img/post-office-white.dab9f133.svg";